


















































































import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import Pusher from '@/modules/user/push/_components/Pusher.vue';
import PostCommentField from '@/modules/user/comments/_components/PostCommentField.vue';
import S3Image from '@/components/S3Image.vue';
import PostLikeField from '@/modules/user/likes/_components/PostLikeField.vue';
import DeleteCommentField from '@/modules/user/comments/_components/DeleteCommentField.vue';
import Loader from '@/components/Loader.vue';
import InfiniteLoading from 'vue-infinite-loading';
import S3Video from '@/components/S3Video.vue';

@Component<Dashboard>({
  components: {
    S3Video,
    Loader,
    DeleteCommentField,
    PostLikeField,
    S3Image,
    PostCommentField,
    Pusher,
    InfiniteLoading,
  },
  beforeRouteEnter(to, from, next) {
    next((vm: Dashboard) => {
      vm.from = from;
    });
  },
})
export default class Dashboard extends Vue {
  public from: any;
  private loading: boolean = true;
  private noSubs: boolean = false;

  @Getter('user/posts/all') private posts!: any;
  @Getter('user/posts/isAllLoaded') private isAllLoaded!: boolean;
  @Getter('user/animals/all') private animals!: any;

  @Action('user/animals/read') private readAnimals!: any;
  @Action('user/posts/read') private readPosts!: any;
  @Action('user/posts/infiniteRead') private infiniteReadPosts!: any;

  private async mounted() {
    this.loading = true;

    try {
      await this.readAnimals();
      await this.readPosts();

      if (!this.posts || this.posts.length === 0) {
        this.noSubs = true;
        if (this.from && ['SignIn', 'SignUp', 'GuestHome'].indexOf(this.from.name) !== -1) {
          this.$router.push({name: 'UserAnimals'});
        }
      }
      this.loading = false;
    } catch (ex) {
      this.loading = false;
    }
  }

  private goToAnimal(animalId: string) {
    if (this.getAnimal(animalId)) {
      this.$router.push({name: 'UserAnimal', params: {id: animalId}});
    }
  }

  private getAnimal(id: string) {
    for (const animal in this.animals) {
      if (this.animals[animal].id === id) {
        return this.animals[animal];
      }
    }
    return null;
  }

  private async infiniteHandler($state) {
    if (this.isAllLoaded) {
      return $state.complete();
    }
    await this.infiniteReadPosts();
    return $state.loaded();
  }

  private getAnimalProfileImage(animalId: string) {
    const animal = this.getAnimal(animalId);
    if (!animal || !animal.profileImage) {
      return '/img/animal/removed.png';
    } else {
      return animal.profileImage.replace('/full/', '/tiny/');
    }
  }

  private getAnimalTitle(animalId: string) {
    const animal = this.getAnimal(animalId);
    if (!animal) {
      return '- Deleted -';
    } else {
      return animal.title;
    }
  }

  private getPostText(description: string) {
    return description ? description.replace(/\n/gm, '</br>') : '';
  }

  private like(post: any) {
    post.liked = !post.liked;
  }
}
